import { render, staticRenderFns } from "./work-item-filter-date-picker.component.vue?vue&type=template&id=498772de&"
import script from "./work-item-filter-date-picker.component.vue?vue&type=script&lang=ts&"
export * from "./work-item-filter-date-picker.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports